import settings from '@config';
import Action from '@lib/Action';
import getPropsBase from '@lib/getProps'

export const map = ({ path }: any) => `${path}`;
export const getProps = getPropsBase(map);


export const defaultRoute = {
	...settings.route,
	action: Action.instanse(),
	webType: 'web', style: { '--button-bar-height': 0 }
};
